import {
  Button,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { url } from "../../baseUrl";
import { useSelector } from "react-redux";
import axios from "axios";
import CustomizedSnackbars from "../../Components/SnackBar/SnackBar";
import Navbar from "../../Components/Navbar/Navbar";

// 🎨 FIRST CLASS ASSIGNMENTS COLORS
const primaryDark = "#1a1e4c";      // Dark Navy
const primaryYellow = "#f5c522";    // Yellow/Gold
const gradientMain = `linear-gradient(135deg, ${primaryDark} 0%, ${primaryYellow} 100%)`;
const lightBg = "#fffdf5";
const white = "#ffffff";

const TransactionForm = () => {
  let { id } = useParams();
  let param = id.split("_");
  const state = useSelector((state) => state.user.data);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState(0);
  const [brand, setBrand] = useState("First Class Assignments");
  const [orderId, setOrderId] = useState("");
  const [packageName, setPackageName] = useState("");
  const [typeOfSale, setTypeOfSale] = useState("");
  const [salesPerson, setSalesPerson] = useState("");
  const [amount, setAmount] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [additionalCharges, setAdditionalCharges] = useState(0);
  const [total, setTotal] = useState(0);
  const [selectDiscription, setSelectDiscription] = useState("");
  const [discription, setDiscription] = useState("");
  const [invoiceLink, setInvoiceLink] = useState("");
  const [allAccounts, setAllAccounts] = useState([]);
  const [account, setAccount] = useState("");
  const [isAccLoaded, setIsAccLoaded] = useState(true);
  const [allTypesOfSale, setAllTypesOfSale] = useState([
    { sale: "New" },
    { sale: "Existing" },
  ]);
  const [isReadOnly, setIsReadOnly] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);

  const linkUrl = window.location.origin;
  const user = useSelector((state) => state.user.data);

  let transactionId = param[0];
  let accessType = param[param.length - 1];

  const navigate = useNavigate();

  const getAllAccounts = async () => {
    try {
      if (accessType === "CREATE") {
        setIsAccLoaded(false);
        await axios.get(`${url}/stripe/getAllAccounts`).then((response) => {
          if (response.data.success) {
            setAllAccounts(response.data.data);
            console.log("response", response.data.data);
            setIsAccLoaded(true);
          } else {
            console.log("error");
          }
        });
      }
    } catch (error) {}
  };
  useEffect(() => {
    getAllAccounts();
  }, []);

  const submitForm = async () => {
    if (
      name &&
      email &&
      number &&
      brand &&
      orderId &&
      typeOfSale &&
      salesPerson &&
      amount &&
      discount &&
      additionalCharges &&
      total &&
      selectDiscription &&
      discription &&
      account
    ) {
      setIsLoaded(true);
      let month;
      const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      const d = new Date();
      month = monthNames[d.getMonth()];
      const data = {
        custName: name,
        custEmail: email,
        custContactNumber: number,
        brand: "First Class Assignments",
        orderId: orderId,
        saleType: typeOfSale,
        salePerson: salesPerson,
        amount,
        discount,
        additionalCharges,
        total,
        discription: selectDiscription,
        detailDiscription: discription,
        year: new Date().getFullYear(),
        month,
        link: linkUrl,
        account,
      };
      await axios
        .post(`${url}/transactions/addnew`, data, {
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        })
        .then(function (response) {
          if (response.data.success) {
            setIsOpen(true);
            setMessage("Record Saved!");
            setSeverity("success");
            setTimeout(() => {
              navigate("/transaction/list");
            }, 2000);
            setIsLoaded(false);
          } else {
            setIsOpen(true);
            setMessage(response.data.message);
            setSeverity("error");
            console.log(response.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
          setIsOpen(true);
          setMessage(error.message);
          setSeverity("error");
        });
      setTimeout(() => {
        setIsOpen(false);
        setIsLoaded(false);
      }, 2000);
    } else {
      setIsOpen(true);
      setMessage("Fill the Required Fields");
      setSeverity("error");
    }
  };
  
  const getSpecificTransaction = async () => {
    if (accessType === "readOnly") {
      await axios
        .post(`${url}/transactions/getSpecificTransaction`, {
          _id: transactionId,
        })
        .then((response) => {
          if (response.data.success) {
            setIsReadOnly(true);
            let ts = response.data.data[0];
            setName(ts.custName);
            setEmail(ts.custEmail);
            setNumber(ts.custContactNumber);
            setBrand(ts.brand);
            setOrderId(ts.orderId);
            setTypeOfSale(ts.saleType);
            setSalesPerson(ts.salePerson);
            setAmount(ts.amount);
            setDiscount(ts.discount);
            setAdditionalCharges(ts.additionalCharges);
            setTotal(ts.total);
            setSelectDiscription(ts.discription);
            setDiscription(ts.detailDiscription);
            setInvoiceLink(ts.invoiceLink);
            setAccount(ts.account);
          }
        });
    }
  };

  useEffect(() => {
    getSpecificTransaction();
  }, []);

  return (
    <>
      <Navbar />
      <Box
        sx={{
          maxWidth: "100%",
          minHeight: "calc(100vh - 70px)",
          background: `linear-gradient(135deg, ${lightBg} 0%, #fff8e0 100%)`,
          p: 2,
          overflowY: "auto",
        }}
      >
        {isAccLoaded ? (
          <Paper
            sx={{
              p: 4,
              borderRadius: "24px",
              background: white,
              boxShadow: "0 10px 30px rgba(26,30,76,0.1)",
              maxWidth: "900px",
              mx: "auto",
              borderTop: `6px solid ${primaryYellow}`,
            }}
          >
            <Box sx={{ textAlign: "center", mb: 3 }}>
              <Typography
                variant="h5"
                sx={{
                  background: gradientMain,
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  color: "transparent",
                  fontWeight: "bold",
                }}
              >
                {accessType === "CREATE" ? "Create New Invoice" : "Invoice Details"}
              </Typography>
            </Box>

            {accessType === "readOnly" && (
              <Grid container>
                <Grid item xs={12}>
                  <TextField
                    name="invoiceLink"
                    label="Invoice Link"
                    type="text"
                    margin="normal"
                    fullWidth
                    disabled={isReadOnly}
                    value={invoiceLink}
                    onChange={(e) => setInvoiceLink(e.target.value)}
                  />
                </Grid>
              </Grid>
            )}

            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <TextField
                  name="name"
                  label="Customer Name"
                  type="text"
                  margin="normal"
                  fullWidth
                  disabled={isReadOnly}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  name="email"
                  label="Customer Email"
                  type="email"
                  margin="normal"
                  fullWidth
                  disabled={isReadOnly}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  name="number"
                  label="Contact Number"
                  type="text"
                  margin="normal"
                  fullWidth
                  disabled={isReadOnly}
                  value={number}
                  onChange={(e) => setNumber(e.target.value)}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <TextField
                  name="orderId"
                  label="Order ID"
                  type="text"
                  margin="normal"
                  fullWidth
                  disabled={isReadOnly}
                  value={orderId}
                  onChange={(e) => setOrderId(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  name="brand"
                  label="Brand Name"
                  type="text"
                  margin="normal"
                  fullWidth
                  disabled={true}
                  value="First Class Assignments"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl margin="normal" fullWidth>
                  <InputLabel sx={{ color: primaryYellow }}>Select Stripe Account</InputLabel>
                  <Select
                    value={account}
                    label="Select Stripe Account"
                    onChange={(e) => setAccount(e.target.value)}
                    disabled={isReadOnly}
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: primaryYellow,
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: primaryDark,
                      },
                    }}
                  >
                    {accessType === "readOnly" ? (
                      <MenuItem value={account}>{account}</MenuItem>
                    ) : allAccounts.length > 0 ? (
                      allAccounts.map((acc) => (
                        <MenuItem key={acc.account} value={acc.account}>
                          {acc.account}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value="">None</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <FormControl margin="normal" fullWidth>
                  <InputLabel sx={{ color: primaryYellow }}>Type Of Sale</InputLabel>
                  <Select
                    value={typeOfSale}
                    label="Type Of Sale"
                    onChange={(e) => setTypeOfSale(e.target.value)}
                    disabled={isReadOnly}
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: primaryYellow,
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: primaryDark,
                      },
                    }}
                  >
                    {accessType === "readOnly" ? (
                      <MenuItem value={typeOfSale}>{typeOfSale}</MenuItem>
                    ) : (
                      allTypesOfSale.map((item) => (
                        <MenuItem key={item.sale} value={item.sale}>
                          {item.sale}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  name="salesPerson"
                  label="Sale's Person"
                  type="text"
                  margin="normal"
                  fullWidth
                  disabled={isReadOnly}
                  value={salesPerson}
                  onChange={(e) => setSalesPerson(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  name="service"
                  label="Service"
                  type="text"
                  margin="normal"
                  fullWidth
                  disabled={isReadOnly}
                  value={selectDiscription}
                  onChange={(e) => setSelectDiscription(e.target.value)}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <TextField
                  name="amount"
                  label="Amount"
                  type="number"
                  margin="normal"
                  fullWidth
                  disabled={isReadOnly}
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  name="discount"
                  label="Discount"
                  type="number"
                  margin="normal"
                  fullWidth
                  disabled={isReadOnly}
                  value={discount}
                  onChange={(e) => setDiscount(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  name="additionalCharges"
                  label="Additional Charges"
                  type="number"
                  margin="normal"
                  fullWidth
                  disabled={isReadOnly}
                  value={additionalCharges}
                  onChange={(e) => setAdditionalCharges(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  name="total"
                  label="Total"
                  type="number"
                  margin="normal"
                  fullWidth
                  disabled
                  value={total}
                />
              </Grid>
            </Grid>

            <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
              <Button
                disabled={isReadOnly}
                onClick={() => {
                  let value = Number(amount) - Number(discount);
                  value = value + Number(additionalCharges);
                  setTotal(value);
                }}
                sx={{
                  border: `1px solid ${primaryYellow}`,
                  color: primaryYellow,
                  borderRadius: "30px",
                  textTransform: "none",
                  px: 4,
                  '&:hover': {
                    background: primaryYellow,
                    color: primaryDark,
                    borderColor: primaryYellow,
                  }
                }}
                variant="outlined"
              >
                Calculate Total
              </Button>
            </Box>

            <Grid container>
              <Grid item xs={12}>
                <TextField
                  name="description"
                  label="Description"
                  type="text"
                  minRows={4}
                  multiline
                  margin="normal"
                  fullWidth
                  disabled={isReadOnly}
                  value={discription}
                  onChange={(e) => setDiscription(e.target.value)}
                />
              </Grid>
            </Grid>

            <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 3 }}>
              {accessType !== "readOnly" && (
                <Button
                  onClick={submitForm}
                  variant="contained"
                  disabled={isLoaded}
                  sx={{
                    background: gradientMain,
                    color: "white",
                    borderRadius: "30px",
                    textTransform: "none",
                    px: 4,
                    '&:hover': {
                      background: primaryYellow,
                      color: primaryDark,
                    }
                  }}
                >
                  {isLoaded ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Generate Link"}
                </Button>
              )}
              <Button
                onClick={() => navigate("/transaction/list")}
                sx={{
                  border: `1px solid ${primaryYellow}`,
                  color: primaryYellow,
                  borderRadius: "30px",
                  textTransform: "none",
                  px: 4,
                  '&:hover': {
                    background: primaryYellow,
                    color: primaryDark,
                  }
                }}
                variant="outlined"
              >
                Back
              </Button>
            </Box>
          </Paper>
        ) : (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "50vh" }}>
            <CircularProgress sx={{ color: primaryYellow }} />
          </Box>
        )}
      </Box>
      <CustomizedSnackbars
        isOpen={isOpen}
        severity={severity}
        message={message}
      />
    </>
  );
};

export default TransactionForm;